module.exports = __webpack_public_path__ + "images/icon/btn_xlsx-ef0a60d7.svg";